import {
  FormAttributionAttributes,
  FormAttributionInteraction,
} from '../types';
import { createFormInteractionEventFromField } from '../event-factories';
import { trackEvent } from './event-tracker';
import { getFormName, getIsFieldEnabled, logger } from '../utils';

export const createFormAttributionHandler = (
  interaction: FormAttributionInteraction,
) => {
  return (event: Event) => {
    let target = event.target;

    if (
      !(target instanceof HTMLInputElement) &&
      !(target instanceof HTMLSelectElement)
    ) {
      return;
    }

    let enabled = getIsFieldEnabled(target);

    if (!enabled) {
      logger.warn(
        `Dropping form attribution event due to disabled field. The dropped field contains the attribute \`${FormAttributionAttributes.FormEnabled}\` with a value which evaluates to false.`,
        target,
      );

      return;
    }

    let formName = getFormName(target);

    if (typeof formName === 'undefined') {
      logger.warn(
        `Dropping form attribution event due to missing form name. Either add a parent form with a name or add the attribute \`${FormAttributionAttributes.FormName}\` to the following field:`,
        target,
      );

      return;
    }

    let interactionEvent = createFormInteractionEventFromField({
      interaction,
      formName,
      field: target,
    });

    trackEvent(interactionEvent);
  };
};
